import * as types from "./actionTypes";
import initialState from "../../reducers/initialState";

export default function dashboardReducer(state = initialState.dashboard, action) {
  switch (action.type) {
    case types.LOAD_CLIENT_OFFER_CHART_DATA_SUCCESS:
      return {
        ...state,
        clientOfferChartData: action.payload
      };

    case types.LOAD_CLIENT_OFFER_STATUS_CHART_DATA_SUCCESS:
      return {
        ...state,
        clientOfferStatusChartData: action.payload
      };

    case types.LOAD_TOP_CLIENTS_CHART_DATA_SUCCESS:
      return {
        ...state,
        topClientsChartData: action.payload
      };

    case types.LOAD_LATEST_CLIENTS_CHART_DATA_SUCCESS:
      return {
        ...state,
        latestClientsChartData: action.payload
      };

    default:
      return state;
  }
}
